<script>
  import { onMount } from 'svelte';
  import { owdCarousel,owdCarouselAuto } from '../../CarouselModule.js';
  const step01_01 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step01_01.webp"
  const step01_02 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step01_02.webp"
  const step01_03 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step01_03.webp"
  const step02_01 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_01.webp"
  const step02_02 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_02.webp"
  const step02_03 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_03.webp"
  const step02_04 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_04.webp"
  const step02_05 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_05.webp"
  const step02_06 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_06.webp"
  const step02_07 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_07.webp"
  const step02_08 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_08.webp"
  const step02_09 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_09.webp"
  const step02_10 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_10.webp"
  const step02_11 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step02_11.webp"
  const step03_01 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_01.webp"
  const step03_02 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_02.webp"
  const step03_03 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_03.webp"
  const step03_04 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_04.webp"
  const step03_05 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_05.webp"
  const step03_06 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_06.webp"
  const step03_07 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_07.webp"
  const step03_08 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_08.webp"
  const step03_09 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_09.webp"
  const step03_10 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_10.webp"
  const step03_11 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_11.webp"
  const step03_12 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_12.webp"
  const step03_13 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_13.webp"
  const step03_14 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_14.webp"
  const step03_15 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step03_15.webp"
  const step04_01 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step04_01.webp"
  const step04_02 = "/assets_default/images/service/debit-card/guide/howto/service_debit-card_guide_howto_step04_02.webp"
  const Chevron = "/assets_default/icons/chevron_right.svg"
  onMount(() => {
    owdCarousel();
    owdCarouselAuto();
  });
</script>

  <page-header text="デビットカードの使い方"></page-header>
  <keyvisual-content
    title="短時間で設定完了<br>デビットでらくらく決済"
    image="/assets_default/images/_dummy/carousel_imagearea.webp"
  >
  </keyvisual-content>
  <div id="section-04">
  <section class="owd-section spacing:bottom:64" id="section-04-01">
    <div class="spacing:bottom:40">
      <div class="align:center">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 01</span>
        </div>
        <h3 class="owd-heading:03 align:center spacing:bottom:24">使う金額を口座に入金しよう</h3>
        <p class="owd-text:01 align:left">デビットカードでお買い物をすると、口座残高から即座にお金が支払われる仕組みになっています。そのため、まずは口座情報を確認して、みんなの銀行への入金が必要です。</p>
      </div>
    </div>

    <div class="splide owd-splide:default" aria-label="owd基本Splide">
      <div class="splide__track owd-wrap:overflow">
        <ul class="splide__list owd-carousel-wrap">
          <li class="owd-carousel-item splide__slide">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src={step01_01} width="268" height="180" alt="みんなの銀行に入金">
            <p class="owd-text:01 spacing:bottom:16"><strong>みんなの銀行に入金</strong></p>
            <p class="owd-text:02">セブン銀行ATM、ほかの銀行口座からの送金でみんなの銀行に入金します。</p>
          </li>
          <li class="owd-carousel-item splide__slide">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src={step01_02} width="268" height="180" alt="人型アイコンをタップ">
            <p class="owd-text:01 spacing:bottom:16"><strong>人型アイコンをタップ</strong></p>
            <p class="owd-text:02">Wallet画面右上の人型アイコンをタップします。</p>
          </li>
          <li class="owd-carousel-item splide__slide">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src={step01_03} width="268" height="180" alt="口座情報を確認">
            <p class="owd-text:01 spacing:bottom:16"><strong>口座情報を確認</strong></p>
            <p class="owd-text:02">口座情報を確認長押しでコピーもできます。</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="show:sp">
      <div class="spacing:bottom:16"></div>
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=mp&adj_t=1tklw4gg" class="owd-button owd-button:large owd-button:primary">口座番号を確認する</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </section>
  <section class="owd-section spacing:bottom:64" id="section-04-02">
    <div class="spacing:bottom:40">
      <div class="align:center">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 02</span>
        </div>
        <h3 class="owd-heading:03 align:center spacing:bottom:24">デビットカードを設定しよう</h3>
        <p class="owd-text:01 align:left">タッチ決済の前に、事前設定をします。設定は1分程度でかんたんに完了します。</p>
      </div>
    </div>
    <div class="spacing:bottom:40">
      <p class="owd-heading:01 spacing:bottom:24">Apple Payの場合</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_01} width="268" height="180" alt="Debit Card画面の「Apple Payに登録する」をタップします。">
              <p class="owd-text:01"><strong>Debit Card画面の「Apple Payに登録する」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_02} width="268" height="180" alt="「Apple Payを設定する」をタップします。">
              <p class="owd-text:01"><strong>「Apple Payを設定する」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_03} width="268" height="180" alt="「次へ」をタップします。">
              <p class="owd-text:01"><strong>「次へ」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_04} width="268" height="180" alt="「完了」画面をタップします。">
              <p class="owd-text:01"><strong>「完了」画面をタップします。</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="spacing:bottom:40">
      <p class="owd-heading:01 spacing:bottom:24">Google Pay の場合</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_05} width="268" height="180" alt="Debit Card画面の「Google Pay に登録する」をタップします。">
              <p class="owd-text:01"><strong>Debit Card画面の「Google Pay に登録する」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_06} width="268" height="180" alt="「Google Pay に追加」をタップします。">
              <p class="owd-text:01"><strong>「Google Pay に追加」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_07} width="268" height="180" alt="「続行」をタップします。">
              <p class="owd-text:01"><strong>「続行」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_08} width="268" height="180" alt="メインカードに設定すると支払いがかんたんにできます。">
              <p class="owd-text:01"><strong>メインカードに設定すると支払いがかんたんにできます。</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="spacing:bottom:40">
      <p class="owd-heading:01 spacing:bottom:24">Apple Watchの場合</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_09} width="268" height="180" alt="Apple Watchでウォレットアプリ を開き、「カードを追加」をタップします。">
              <p class="owd-text:01"><strong>Apple Watchでウォレットアプリ を開き、「カードを追加」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_10} width="268" height="180" alt="「クレジットカードなど」をタップします。">
              <p class="owd-text:01"><strong>「クレジットカードなど」をタップします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step02_11} width="268" height="180" alt="画面に表示される指示に従って設定します。">
              <p class="owd-text:01"><strong>画面に表示される指示に従って設定します。</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="show:sp">
      <div class="spacing:bottom:16"></div>
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=dt&adj_t=1tfhkcwn" class="owd-button owd-button:large owd-button:primary">デビットカードを設定する</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </section>
  <section class="owd-section spacing:bottom:64" id="section-04-03">
    <div class="spacing:bottom:40">
      <div class="align:center">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 03</span>
        </div>
        <h3 class="owd-heading:03 align:center spacing:bottom:24">デビットカードで支払ってみよう</h3>
        <p class="owd-text:01 align:left">支払いの際はみんなの銀行デビットカードを設定したスマホでかざすだけ。かんたんに支払いができます。</p>
      </div>
    </div>
    <div class="spacing:bottom:40">
      <p class="owd-heading:01 spacing:bottom:12">お店で支払い（Apple Payの場合）</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_01} width="268" height="180" alt="「QUICPay+」や「JCBのタッチ決済」のマークがあるか確認します。">
              <p class="owd-text:01"><strong>「QUICPay+」や「JCBのタッチ決済」のマークがあるか確認します。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_02} width="268" height="180" alt="サイドボタンをダブルクリックしてみんなの銀行デビットカードを選択します。">
              <p class="owd-text:01 spacing:bottom:16"><strong>サイドボタンをダブルクリックしてみんなの銀行デビットカードを選択します。</strong></p>
              <ul class="owd-list:annotation">
                <li>利用される機種に応じ、支払い時の操作が異なります。iPhoneを利用の場合は<a href="https://www.quicpay.jp/guide/iphone/howto.html" target="_blank" class="owd-textlink">こちら</a>を確認してください。</li>
              </ul>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_03} width="268" height="180" alt="「クイックペイで」または「JCBのタッチ決済で」と伝えて支払います。">
              <p class="owd-text:01"><strong>「クイックペイで」または「JCBのタッチ決済で」と伝えて支払います。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_04} width="268" height="180" alt="タッチをして決済完了です。">
              <p class="owd-text:01"><strong>タッチをして決済完了です。</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="spacing:bottom:40">
      <p class="owd-heading:01 spacing:bottom:12">お店で支払い（Google Payの場合）</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_05} width="268" height="180" alt="「QUICPay+™（クイックペイプラス）」のマークがあるか確認します。">
              <p class="owd-text:01"><strong>「QUICPay+™（クイックペイプラス）」のマークがあるか確認します。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_06} width="268" height="180" alt="支払い方法としてみんなの銀行デビットカードを選択します。">
              <p class="owd-text:01 spacing:bottom:16"><strong>支払い方法としてみんなの銀行デビットカードを選択します。</strong></p>
              <ul class="owd-list:annotation">
                <li>利用される機種に応じ、支払い時の操作が異なります。Android™を利用の場合は<a href="https://www.quicpay.jp/guide/android/howto.html" target="_blank" class="owd-textlink">こちら</a>を確認してください。</li>
              </ul>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_07} width="268" height="180" alt="「クイックペイで」と伝えて支払います。">
              <p class="owd-text:01"><strong>「クイックペイで」と伝えて支払います。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_08} width="268" height="180" alt="かざして決済完了です。">
              <p class="owd-text:01"><strong>かざして決済完了です。</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="spacing:bottom:20">
      <p class="owd-heading:01 spacing:bottom:12">お店で支払い（リアルカードの場合）</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_14} width="268" height="180" alt="「JCB」の マークがあるか確認します。">
              <p class="owd-text:01"><strong>「JCB」の マークがあるか確認します。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_15} width="268" height="180" alt="「JCBで」「カードで」と伝えてお店の端末にカードを差し込み支払います。">
              <p class="owd-text:01 spacing:bottom:16"><strong>「JCBで」「カードで」と伝えてお店の端末にカードを差し込み支払います。</strong></p>
              <ul class="owd-list:annotation">
                <li>タッチ決済対応店舗では、カードを端末にタッチして支払いもできます。</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="spacing:bottom:20">
      <p class="owd-heading:01 spacing:bottom:12">ネットショッピングで支払い</p>
      <div class="splide owd-splide:default" aria-label="owd基本Splide">
        <div class="splide__track owd-wrap:overflow">
          <ul class="splide__list owd-carousel-wrap">
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_09} width="268" height="180" alt="「JCB」のマークがあるか確認します。">
              <p class="owd-text:01"><strong>「JCB」のマークがあるか確認します。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_10} width="268" height="180" alt="画面の該当箇所を長押ししてコピーします。">
              <p class="owd-text:01"><strong>画面の該当箇所を長押ししてコピーします。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_11} width="268" height="180" alt="支払い方法で「クレジットカード払い」または「カード払い」を選択します。">
              <p class="owd-text:01 spacing:bottom:16"><strong>支払い方法で「クレジットカード払い」または「カード払い」を選択します。</strong></p>
              <ul class="owd-list:annotation">
                <li>「デビットカード払い」がある場合は「デビットカード払い」を選択します。</li>
              </ul>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_12} width="268" height="180" alt="デビットカード情報を入力します。">
              <p class="owd-text:01"><strong>デビットカード情報を入力します。</strong></p>
            </li>
            <li class="owd-carousel-item splide__slide">
              <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
              <img class="spacing:bottom:24" src={step03_13} width="268" height="180" alt="画面の案内に従って支払い完了です。">
              <p class="owd-text:01"><strong>画面の案内に従って支払い完了です。</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="owd-servicelist:wrapper bg-colors:light-gray spacing:bottom:40">
      <p class="owd-heading:05 spacing:bottom:12">「J/Secure」でもっと安全に</p>
      <p class="owd-caption">「J/Secureワンタイムパスワード」を設定すると、パスワードの漏洩や使い回しによる「なりすまし被害」の防止に役立ち、高い安全性を確保できます。</p>
      <div class="show:sp">
        <div class="spacing:bottom:16"></div>
        <div class="block:center spacing:bottom:16">
          <a href="https://minna-no-ginko.go.link/?tp=pg&pg=dos&adj_t=1t5wulia" class="owd-button owd-button:large owd-button:secondary:white">ワンタイムパスワードを設定する</a>
        </div>
        <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
      </div>
    </div>


  </section>
  <section class="owd-section spacing:bottom:64" id="section-04-04">
    <div class="spacing:bottom:40">
      <div class="align:center">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 04</span>
        </div>
        <h3 class="owd-heading:03 align:center spacing:bottom:24">支払い内容の確認</h3>
        <p class="owd-text:01 align:left">デビットカードで支払うと、すぐにアプリでお知らせします。今月いくら使ったかをアプリで確認することができるので、残りいくら使えるのかを把握しながら、使いすぎを防ぐことができます。</p>
      </div>
    </div>

    <div class="splide owd-splide:default" aria-label="owd基本Splide">
      <div class="splide__track owd-wrap:overflow">
        <ul class="splide__list owd-carousel-wrap">
          <li class="owd-carousel-item splide__slide">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src={step04_01} width="268" height="180" alt="デビットカードでの支払いがあるとプッシュ通知でお知らせします。">
            <p class="owd-text:01"><strong>デビットカードでの支払いがあるとプッシュ通知でお知らせします。</strong></p>
          </li>
          <li class="owd-carousel-item splide__slide">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src={step04_02} width="268" height="180" alt="Debit Card画面の利用明細を見るをタップします。">
            <p class="owd-text:01"><strong>Debit Card画面の利用明細を見るをタップします。</strong></p>
          </li>
          <li class="owd-carousel-item splide__slide">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src={step04_02} width="268" height="180" alt="デビットカードの利用明細や月ごとの利用合計額などを確認します。">
            <p class="owd-text:01"><strong>デビットカードの利用明細や月ごとの利用合計額などを確認します。</strong></p>
          </li>
        </ul>
      </div>
    </div>

    <div class="show:sp">
      <div class="spacing:bottom:40"></div>
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=rmd&adj_t=1tp8sudl" class="owd-button owd-button:large owd-button:primary">利用明細を確認する</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </section>
  </div>
  <section class="owd-section spacing:bottom:64">
    <ul class="owd-framedlinklist spacing:bottom:64 modal-none">
      <li class="owd-framedlinklist-item spacing:bottom:12">
        <a href="/service/debit-card/guide/about/" class="owd-framedlinklist-flex">
          <div>
            <p class="owd-heading:04 spacing:bottom:12">デビットカードの基本</p>
            <p class="owd-text:02">クレジットカードや現金払いとの違いは？</p>
          </div>
          <img src={Chevron} alt="右矢印アイコン">
        </a>
      </li>
      <li class="owd-framedlinklist-item">
        <a href="/service/debit-card/guide/place/" class="owd-framedlinklist-flex">
          <div>
            <p class="owd-heading:04 spacing:bottom:12">使える場所</p>
            <p class="owd-text:02">全国のコンビニやスーパーなどあらゆる場所で利用できます</p>
          </div>
          <img src={Chevron} alt="右矢印アイコン">
        </a>
      </li>
    </ul>

    <ul class="owd-list:mix:01">
      <li>
        <p class="owd-heading:05 spacing:bottom:16">申込みに関する注意事項</p>
        <ul class="owd-list:annotation">
          <li>口座開設と同時にアプリ内に自動発行されます。なお、メルカリ支店を利用中の方は、口座開設と同時にバーチャルデビットが発行されません。みんなの銀行アプリをダウンロード後、アプリから申込みが必要です。</li>
          <li>申込みの際、発行審査にお時間がかかる場合があります。</li>
          <li>申込みの結果、デビットカードの発行をお断りさせていただく場合があります。その場合、お断りの理由は回答いたしかねます。</li>
          <li>追加口座ではデビットカードを発行できません。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">お店で支払いする場合の注意事項</p>
        <ul class="owd-list:annotation">
          <li>利用のスマートフォンがタッチ決済可能な端末であり、タッチ決済に対応しているお店で利用できます。</li>
          <li>QUICPay™（クイックペイ）はApple Pay、Google Pay に対応しています。</li>
          <li>JCBのタッチ決済はApple Payに対応しています。</li>
          <li>利用の機種に応じ、支払い時の操作が異なります。iPhoneを利用の場合は<a class="owd-textlink:blank" href="https://www.quicpay.jp/guide/iphone/howto.html" target="_blank">こちら</a>を確認してください。Android™ を利用の場合は<a class="owd-textlink:blank" href="https://www.quicpay.jp/guide/android/howto.html" target="_blank">こちら</a>を確認してください。</li>
          <li>お持ちのスマートフォンによっては、顔認証や指紋認証が求められる場合があります。</li>
          <li>Apple Payを利用するには最新バージョンのiOSが必要です。Apple Payに対応しているデバイスについては<a class="owd-textlink:blank" href="https://support.apple.com/ja-jp/102896" target="_blank">こちら</a>を確認してください。</li>
          <li>Apple Payは、米国およびほかの国々で登録されたApple Inc. の商標です。</li>
          <li>Google Pay は、Google ウォレットアプリをダウンロードできるスマートフォンで使えます。Android OSのバージョンは、<a class="owd-textlink:blank" href="https://support.google.com/wallet/answer/13314575" target="_blank">Google ウォレットのサポートページ</a>を確認してください。</li>
          <li>Android、Google Pay は、Google LLC の商標です。</li>
          <li>QUICPay+は、株式会社ジェーシービーの登録商標です。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">ネットで支払いする場合の注意事項</p>
        <ul class="owd-list:annotation">
          <li>3Dセキュア（J/Secure™）とは、ネットショッピングでの第三者による不正利用を防ぐための「本人認証サービス」です。必要に応じて本人認証（パスワード認証）を行います。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">デビットカード利用時の注意事項（お店・ネット共通）</p>
        <ul class="owd-list:annotation">
          <li>原則、利用時に普通預金口座から即時引落しとなりますが、一部の加盟店では後日払いとなるケースや差額引落しが発生するケースがあります。その際に口座残高が不足していた場合は、一定期間にわたり振替による引落しの手続きをさせていただきます。</li>
          <li>高速道路料金、ガソリンスタンド、機内販売、登録型加盟店（カード番号を登録し、継続的に利用額を支払いただく加盟店）など、一部利用できない加盟店があります。</li>
          <li>詳しくは<a href="/service/debit-card/summary/" class="owd-textlink">こちら</a>を確認してください。</li>
        </ul>
      </li>
    </ul>
  </section>
